import React, { useState } from 'react';
import { flattenRichText } from 'utils/richTextUtils';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';
import getButtonStyles from 'components/Core/Button/utils/getButtonStyles';
import Button from 'components/Core/Button';
import { getRTInlineMarketingFormProps } from 'utils/marketo';
import { RichTextCtaContainer } from './styles';

const RichTextCta = ({ dataPosition, fields, alignDesktop, alignMobile, ...otherProps }) => {
  const [isModalOpen, toggleIsModalOpen] = useState(false);

  const { buttonLabel, color, modalForm, url, useModalForm } = flattenRichText(fields) || {};
  const formProps = modalForm && getRTInlineMarketingFormProps(modalForm?.fields || modalForm);

  return (
    <RichTextCtaContainer alignDesktop={alignDesktop} alignMobile={alignMobile} {...otherProps}>
      <Button
        className="test-embedded-cta"
        to={useModalForm ? null : url}
        onClick={useModalForm ? () => toggleIsModalOpen(true) : null}
        dataPosition="Embedded CTA"
        type={getButtonStyles(color)}
      >
        {buttonLabel}
      </Button>
      {useModalForm && formProps?.marketoForm && (
        <>
          <ModalMarketingForm
            dataPosition={dataPosition}
            isModalOpen={isModalOpen}
            onModalCancel={() => toggleIsModalOpen(false)}
            inlineMarketingForm={formProps}
            onFormSuccess={() => toggleIsModalOpen(false)}
          />
        </>
      )}
    </RichTextCtaContainer>
  );
};

export default RichTextCta;
